import { render, staticRenderFns } from "./PayConfig.vue?vue&type=template&id=0c42311b&scoped=true&"
import script from "./PayConfig.vue?vue&type=script&lang=js&"
export * from "./PayConfig.vue?vue&type=script&lang=js&"
import style0 from "./PayConfig.vue?vue&type=style&index=0&id=0c42311b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42311b",
  null
  
)

export default component.exports